<template>
    <div>
        <validation-observer ref="validationRules">
            <template v-if="modelValue.on_edit">
                <div v-if="isAnggota" class="row mb-1">
                    <div class="col-12 d-flex flex-row" style="gap: 5px">
                        <b-form-radio v-model="formDatas.is_pns" name="some-radios" :value="true">
                            ASN
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.is_pns" name="some-radios" :value="false">
                            NON ASN
                        </b-form-radio>
                    </div>
                </div>
                <template v-if="formDatas.is_pns">
                    <div v-if="modelValue.ref_jabatan_ba_tim_kode == 'ketua'" class="row mb-1">
                        <div class="col-12 mb-1">
                            Nama Kepala : {{ parentData.nama_ka_siera }}
                            <br />
                            NIP : {{ parentData.nip_ka_siera }}
                        </div>
                        <div class="col-12 d-flex flex-row align-items-center" style="gap: 5px">
                            <small class="text-danger">NRK yang diinput harus sesuai dengan data kepala PD/UKPD/UPB yang ada
                                pada master profile. Apabila profile PD/UKPD/UPB belum sesuai, silahkan perbaiki melalui
                                sistem SIERA</small>
                        </div>
                    </div>
                    <div v-if="['ketua', 'wakil', 'sekretaris'].includes(modelValue.ref_jabatan_ba_tim_kode)"
                        class="row mb-1">
                        <div class="col-12 d-flex flex-row" style="gap: 5px">
                            <b-form-checkbox v-model="formDatas.is_plt" name="some-radios" :value="'iya'"
                                :unchecked-value="'tidak'">
                                PLT
                            </b-form-checkbox>
                        </div>
                    </div>

                    <div class="row mb-1">
                        <div class="col-12">
                            <span class="font-weight-bold text-muted">NRK</span>
                        </div>
                        <div class="col-12">
                            <validation-provider #default="{ errors }" name="NRK Pegawai" rules="required">
                                <b-input-group>
                                    <cleave id="cardNumber" v-model="formDatas.nrk" :options="nrkCleaveOption"
                                        class="form-control" :raw="false" placeholder="Input NRK Pegawai" />
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </div>
                    </div>
                </template>
                <div v-if="isAnggota && !formDatas.is_pns" class="row mb-1">
                    <div class="col-12">
                        <span class="font-weight-bold text-muted">NAMA</span>
                    </div>
                    <div class="col-12">
                        <validation-provider #default="{ errors }" name="Nama Pegawai" rules="required">
                            <b-input-group>
                                <b-form-input id="namaPegawai" v-model="formDatas.nama" placeholder="Input Nama Pegawai" />
                            </b-input-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12">
                        <div class="d-flex flex-wrap justify-content-between" style="gap: 5px;">
                            <div class="d-inline-flex flex-wrap" style="gap: 5px">
                                <div>
                                    <b-button v-if="!loadingSubmit" variant="primary" size="sm" style="margin-right: 5px;"
                                        @click="updateParent">
                                        <span class="align-middle">Submit</span>
                                    </b-button>
                                    <b-button v-else variant="primary" disabled size="sm" class="mr-1">
                                        <b-spinner small />
                                        Loading...
                                    </b-button>
                                </div>
                                <div>
                                    <b-button variant="secondary" size="sm" style="margin-right: 5px;"
                                        @click="cancelUpdate">
                                        <span class="align-middle">Batal</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <hr />
            <div class="row mb-1">
                <div class="col-12 col-md-4 col-lg-4">
                    <div>
                        <span class="font-weight-bold text-dark">NRK</span>
                    </div>
                    <div class="">
                        <span class="text-dark">{{ modelValue.nrk || '-' }}</span>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div>
                        <span class="font-weight-bold text-dark">NAMA</span>
                    </div>
                    <div class="">
                        <span class="text-dark">{{ modelValue.nama || '-' }}</span>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div>
                        <span class="font-weight-bold text-dark">NIP</span>
                    </div>
                    <div class="">
                        <span class="text-dark">{{ modelValue.nip || '-' }}</span>
                    </div>
                </div>
            </div>
        </validation-observer>
    </div>
</template>
  
<script>
import { ref } from '@vue/composition-api'
import vSelect from "vue-select";
import skTim from "@/composables/b/skTim";
import { id as localeId } from "vee-validate/dist/locale/id";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import { showNotifikasi } from '@/libs/helper';

export default {
    props: {
        parentData: { type: Object },
        modelValue: { type: Object },
        index: Number,
        updateItem: Function,
        isAnggota: { type: Boolean, default: false }
    },
    setup(props, context) {
        localize('id', localeId);
        const g = context.root;
        const formDatas = ref({
            kolok: props.modelValue.kolok,
            is_pns: true,
            is_plt: props.modelValue.is_plt,
            nrk: props.modelValue.nrk,
            nama: props.modelValue.nama,
            nip: props.modelValue.nip,
            ref_jabatan_ba_tim_kode: props.modelValue.ref_jabatan_ba_tim_kode,
        });
        const inputVal = ref();
        const handleInputNrk = () => {
            formDatas.value.nrk = formDatas.value.nrk.replace(/[^0-9]/g, '').slice(0, 5);
            // Remove non-numeric characters and limit to 5 characters
        }

        const cancelUpdate = () => {
            let newFd = {
                ...props.modelValue,
                on_edit: false
            };
            let oldFd = { ...props.modelValue };
            props.updateItem(props.index, newFd, oldFd, 'cancel');
        };

        const loadingSubmit = ref(false);
        const updateParent = () => {
            let oldFd = { ...props.modelValue };
            let newFd = {
                id: props.modelValue.id,
                ref_jabatan_ba_tim_kode: props.modelValue.ref_jabatan_ba_tim_kode,
            };
            loadingSubmit.value = true;
            context.refs.validationRules.validate().then(success => {
                if (success) {
                    if (formDatas.value.is_pns) {
                        if (formDatas.value.nrk == props.modelValue.nrk) {
                            newFd = {
                                ...newFd,
                                nrk: props.modelValue.nrk,
                                nama: props.modelValue.nama,
                                nip: props.modelValue.nip,
                                is_plt: formDatas.value.is_plt,
                                on_edit: false
                            };
                            props.updateItem(props.index, newFd, oldFd, 'update');
                            loadingSubmit.value = false;
                        } else {
                            skTim.getNrkSingleData(g, formDatas.value).then(resp => {
                                if (resp.data && resp.code == 200) {
                                    newFd = {
                                        ...newFd,
                                        nrk: resp.data.nrk,
                                        nama: resp.data.nama,
                                        nip: resp.data.nip,
                                        is_plt: formDatas.value.is_plt,
                                        on_edit: false
                                    };
                                    props.updateItem(props.index, newFd, oldFd, 'update');
                                } else {
                                    showNotifikasi(g, 'warning', 'Warning', resp.message)
                                }
                                loadingSubmit.value = false;
                            }).catch((err) => {
                                loadingSubmit.value = false;
                                console.log(err);
                                return;
                            });
                        }

                    } else {
                        newFd = {
                            ...newFd,
                            kolok: formDatas.value.kolok,
                            nrk: null,
                            nama: formDatas.value.nama,
                            nip: null,
                            is_plt: formDatas.value.is_plt,
                            on_edit: false
                        };
                        props.updateItem(props.index, newFd, oldFd, 'update');
                        loadingSubmit.value = false;
                    }
                } else {
                    setTimeout(() => {
                        loadingSubmit.value = false;

                    }, 1000)
                }
            });
        };
        return {
            formDatas,
            inputVal,
            cancelUpdate,
            updateParent,
            handleInputNrk,
            loadingSubmit
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect,
        Cleave
    },
    methods: {

    },
    data() {
        return {
            required,
            nrkCleaveOption: {
                blocks: [100], // Specify the blocks with the desired length
                numericOnly: true,
            },
        }
    },
}
</script>
  